import { ScanLine, UploadCloud } from "lucide-react";
import { ChangeEvent, useState } from "react";
import { api } from "../lib/api";
import type { OcrReview } from "../types";

export function UploadScreenshot() {
  const [file, setFile] = useState<File | null>(null);
  const [review, setReview] = useState<OcrReview | null>(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  function chooseFile(event: ChangeEvent<HTMLInputElement>) {
    setFile(event.target.files?.[0] ?? null);
    setReview(null);
    setMessage("");
    setError("");
  }

  async function upload() {
    if (!file) {
      setError("请先选择截图");
      return;
    }

    setBusy(true);
    setError("");
    setMessage("");

    try {
      const data = await api.uploadScreenshot(file);
      setReview(data.review);
      setMessage("截图已上传到 R2");
    } catch (err) {
      setError(err instanceof Error ? err.message : "上传失败");
    } finally {
      setBusy(false);
    }
  }

  async function recognize() {
    if (!review) {
      return;
    }

    setBusy(true);
    setError("");
    setMessage("");

    try {
      const data = await api.recognize(review.id);
      setReview(data.review);
      setMessage("OCR 已完成，请进入 Review OCR 确认");
    } catch (err) {
      setError(err instanceof Error ? err.message : "识别失败");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="page-stack">
      <header className="page-header">
        <div>
          <p className="eyebrow">Upload Screenshot</p>
          <h1>截图上传</h1>
        </div>
      </header>

      {message ? <div className="notice success">{message}</div> : null}
      {error ? <div className="notice danger">{error}</div> : null}

      <section className="panel upload-panel">
        <label className="drop-zone">
          <UploadCloud size={28} aria-hidden />
          <span>{file ? file.name : "选择订单截图"}</span>
          <input accept="image/*" onChange={chooseFile} type="file" />
        </label>

        <div className="button-row">
          <button
            className="primary-button"
            disabled={!file || busy}
            onClick={upload}
            type="button"
          >
            <UploadCloud size={17} aria-hidden />
            {busy ? "处理中..." : "上传截图"}
          </button>
          <button
            className="secondary-button"
            disabled={!review || busy}
            onClick={recognize}
            type="button"
          >
            <ScanLine size={17} aria-hidden />
            开始识别
          </button>
        </div>

        {review ? (
          <div className="result-box">
            <p>
              <strong>Review ID：</strong>
              {review.id}
            </p>
            <p>
              <strong>R2 Key：</strong>
              {review.screenshot_key}
            </p>
            <p>
              <strong>状态：</strong>
              {review.status}
            </p>
          </div>
        ) : null}
      </section>
    </section>
  );
}
